import { ConfirmationBox, Labeled, TextInput } from '@infotech-soe/erp-ui-kit';
import React, { useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useStyles as useDialogStyles } from '../../dialogs/styles';

interface Props {
  value: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
  validate: (value: string) => boolean;
}

const messages = defineMessages({
  newName: {
    id: 'core.category.grid.config.preset.rename.dialog.title',
    defaultMessage: 'New preset name',
  },
  inputLabel: {
    id: 'core.category.grid.config.preset.rename.dialog.label',
    defaultMessage: 'Enter new preset name',
  },
});

const RenamePresetForm: React.FC<Props> = ({
  value,
  open,
  validate = () => true,
  onCancel,
  onConfirm,
}) => {
  const dialogClasses = useDialogStyles();
  const { formatMessage } = useIntl();

  const [name, setName] = useState(value);

  useEffect(() => setName(open ? value : ''), [value, open]);

  return (
    <ConfirmationBox
      className={dialogClasses.dialog}
      open={open}
      submitForbidden={!name || !validate(name)}
      title={formatMessage(messages.newName)}
      onCancel={onCancel}
      onClose={onCancel}
      onConfirm={() => onConfirm(name)}
    >
      <Labeled label={formatMessage(messages.inputLabel)}>
        <TextInput
          invalid={!validate(name)}
          required
          value={name}
          onChange={setName}
          onSubmit={() => onConfirm(name)}
        />
      </Labeled>
    </ConfirmationBox>
  );
};
export default RenamePresetForm;
